/* Billy announcement banner: rotates messages; pauses on hover, touch, focus or hidden tab. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (bar) => {
    if (bar.billyAnnTimer) clearInterval(bar.billyAnnTimer);
    const items = Array.from(bar.querySelectorAll('[data-ann-item]'));
    if (items.length < 2 || reduce.matches) return;

    let index = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));
    let paused = false;
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    bar.addEventListener('mouseenter', pause);
    bar.addEventListener('mouseleave', resume);
    bar.addEventListener('focusin', pause);
    bar.addEventListener('focusout', resume);
    bar.addEventListener('touchstart', () => { paused = !paused; }, { passive: true });

    const ms = (Number(bar.dataset.interval) || 5) * 1000;
    bar.billyAnnTimer = setInterval(() => {
      if (paused || document.hidden) return;
      const prev = items[index];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), 500);
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, ms);
  };

  const boot = () => document.querySelectorAll('[data-billy-ann][data-style="rotate"]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
